import type { FeatureModule } from "@theg1group/feature-kit";

/** Sidebar nav for emailnetwork.g1.network, rendered by @theg1group/app-shell.
 *  Icon names resolve to lucide-react via the shell's resolveIcon. */
export const emailnetworkNav: FeatureModule = {
	id: "emailnetwork-nav",
	nav: [
		{ id: "overview", label: "Overview", path: "/overview", order: 0, icon: "LayoutDashboard" },
		{ id: "files", label: "Files / Inbox", path: "/files", order: 1, icon: "Mail" },
		{ id: "graph", label: "Graph", path: "/graph", order: 2, icon: "Network" },
		{ id: "brands", label: "Brands", path: "/brands", order: 3, icon: "Target" },
		{ id: "monitor", label: "Monitor", path: "/monitor", order: 4, icon: "ShieldAlert" },
		{ id: "timeline", label: "Timeline", path: "/timeline", order: 3, icon: "Timer" },
		{ id: "cases", label: "Cases", path: "/cases", order: 4, icon: "FileSearch" },
		{ id: "mailboxes", label: "Mailboxes", path: "/mailboxes", order: 5, icon: "Inbox" },
	],
	routes: [],
};
